import React from 'react'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

export enum CloseCycleStatusContextActionTypes {
  SHOW_CLOSE_CYCLE_STATUS_MODAL = 'SHOW_CLOSE_CYCLE_STATUS_MODAL',
  HIDE_CLOSE_CYCLE_STATUS_MODAL = 'HIDE_CLOSE_CYCLE_STATUS_MODAL',
}

export enum PayrollContextActionTypes {
  SWOW_CHANGE_POLICY_MODAL = 'SHOW_CHANGE_POLICY_MODAL',
  HIDE_CHANGE_POLICY_MODAL = 'HIDE_CHANGE_POLICY_MODAL',
}

export enum ChangeStatusModalActionTypes {
  SHOW_CHANGE_STATUS_MODAL = 'SHOW_CHANGE_STATUS_MODAL',
  HIDE_CHANGE_STATUS_MODAL = 'HIDE_CHANGE_STATUS_MODAL',
}

interface ShowChangeStatusModalAction {
  type: ChangeStatusModalActionTypes.SHOW_CHANGE_STATUS_MODAL
  payload: PayrollStatus
}

interface HideChangeStatusModalAction {
  type: ChangeStatusModalActionTypes.HIDE_CHANGE_STATUS_MODAL
}

interface ShowChangePolicyModalAction {
  type: PayrollContextActionTypes.SWOW_CHANGE_POLICY_MODAL
}

interface HideChangePolicyModalAction {
  type: PayrollContextActionTypes.HIDE_CHANGE_POLICY_MODAL
}

interface ShowCloseCycleStatusModalAction {
  type: CloseCycleStatusContextActionTypes.SHOW_CLOSE_CYCLE_STATUS_MODAL
}

interface HideCloseCycleStatusModalAction {
  type: CloseCycleStatusContextActionTypes.HIDE_CLOSE_CYCLE_STATUS_MODAL
}

type Actions =
  | ShowChangePolicyModalAction
  | HideChangePolicyModalAction
  | ShowCloseCycleStatusModalAction
  | HideCloseCycleStatusModalAction
  | ShowChangeStatusModalAction
  | HideChangeStatusModalAction

export interface State {
  showChangePolicyModal: boolean
  showChangeStatusModal: boolean
  showCloseCycleStatusModal: boolean
  payrollDispatch: React.Dispatch<Actions>
  selectedStatus: PayrollStatus
}

const initialState: State = {
  showChangePolicyModal: false,
  showChangeStatusModal: false,
  showCloseCycleStatusModal: false,
  payrollDispatch: () => null,
  selectedStatus: PayrollStatus.PREPARATION,
}

const PayrollContext: React.Context<State> = React.createContext(initialState)

function reducer(state: State, action: Actions) {
  switch (action.type) {
    case PayrollContextActionTypes.SWOW_CHANGE_POLICY_MODAL: {
      return { ...state, showChangePolicyModal: true }
    }

    case PayrollContextActionTypes.HIDE_CHANGE_POLICY_MODAL: {
      return { ...state, showChangePolicyModal: false }
    }

    case CloseCycleStatusContextActionTypes.SHOW_CLOSE_CYCLE_STATUS_MODAL: {
      return { ...state, showCloseCycleStatusModal: true }
    }

    case CloseCycleStatusContextActionTypes.HIDE_CLOSE_CYCLE_STATUS_MODAL: {
      return { ...state, showCloseCycleStatusModal: false }
    }

    case ChangeStatusModalActionTypes.SHOW_CHANGE_STATUS_MODAL: {
      return { ...state, showChangeStatusModal: true, selectedStatus: action.payload }
    }

    case ChangeStatusModalActionTypes.HIDE_CHANGE_STATUS_MODAL: {
      return { ...state, showChangeStatusModal: false }
    }

    default:
      return state
  }
}

interface Props {
  children: React.ReactNode
}

export const PayrollProvider = ({ children }: Props) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  return (
    <PayrollContext.Provider value={{ ...state, payrollDispatch: dispatch }}>
      {children}
    </PayrollContext.Provider>
  )
}

export const usePayrollContext = () => {
  const payrollPayments = React.useContext(PayrollContext)

  if (!payrollPayments) {
    throw new Error('usePayrollContext hook must be used within a PayrollProvider')
  }

  return payrollPayments
}
